import React from 'react';
import { FaEdit, FaTrash, FaProjectDiagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardContent } from '../ui/card';

function TaskCard({ 
  task, 
  viewMode = 'card', // 'card' or 'list'
  onEdit,
  onDelete
}) {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 1: return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
      case 2: return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400';
      case 3: return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
      case 4: return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
      case 5: return 'bg-gray-50 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
      default: return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case 1: return 'Critical';
      case 2: return 'High';
      case 3: return 'Medium';
      case 4: return 'Low';
      case 5: return 'Lowest';
      default: return 'Medium';
    }
  };

  const cardClasses = viewMode === 'list' 
    ? 'mb-2'
    : 'mb-3';

  const cardStyle = viewMode === 'list' 
    ? { minHeight: '80px' }
    : { minHeight: '160px' };

  return (
    <Card className={`task-card ${cardClasses} hover:shadow-lg transition-shadow`} style={cardStyle}>
      <CardHeader className={viewMode === 'list' ? 'py-2' : ''}>
        <div className={`flex justify-between items-start ${viewMode === 'list' ? 'mb-1' : 'mb-2'}`}>
          <h3 className={`${viewMode === 'list' ? 'text-sm' : 'text-base'} font-medium text-gray-900 dark:text-gray-100`}>
            {task.name}
          </h3>
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ml-2 ${getPriorityColor(task.priority)}`}>
            {getPriorityText(task.priority)}
          </span>
        </div>
      </CardHeader>
      
      <CardContent className={viewMode === 'list' ? 'py-2' : ''}>
        {viewMode === 'card' && task.description && (
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {task.description}
          </p>
        )}

        <div className={`flex justify-between items-center ${viewMode === 'list' ? 'mt-1' : ''}`}>
          <div className="flex items-center">
            <FaProjectDiagram className="mr-1 text-gray-500 dark:text-gray-400" />
            <small className="text-gray-500 dark:text-gray-400">
              <Link 
                to={`/project/${task.projects?.id}`} 
                className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 no-underline"
              >
                {task.projects?.name}
              </Link>
            </small>
          </div>
          <div className="flex items-center gap-1">
            <button 
              className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 dark:text-gray-400 dark:hover:text-blue-400 dark:hover:bg-blue-900/20 transition-colors rounded"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Edit clicked for task:', task.id);
                onEdit?.(task);
              }}
              title="Edit Task"
            >
              <FaEdit />
            </button>
            <button 
              className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 dark:text-gray-400 dark:hover:text-red-400 dark:hover:bg-red-900/20 transition-colors rounded"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Delete clicked for task:', task.id);
                onDelete?.(task);
              }}
              title="Delete Task"
            >
              <FaTrash />
            </button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default TaskCard;
